<ca-modal-container [modalTitle]="title" [isTitleCentered]="false" [isBodyCentered]="false" (dismiss)="close()" data-uit="modal-success">
    <ca-icon name="success" size="s" class="ca-color-icon-info info-icon" [removeSVGAttributes]="['stroke']"></ca-icon>
    <div class="d-flex mt-3">
        <p>{{ message }}</p>
    </div>
    <div class="d-flex justify-content-end mt-4">
        <button type="button" caAutoFocus class="w-100 btn btn-primary" (click)="close()" data-uit="modal-success-done-button">
            {{ buttonText }}
        </button>
    </div>
</ca-modal-container>
